export default {
    getFaqFilter: state => state.filter,
    getFaqList: state => state.list,
    getFaqValidation: state => state.validation
}